import * as React from 'react';

interface ButtonProps {
  id: string;
  label: string;
  className?: string;
  onClick?: Function;
  onKeyDown?: Function;
  onBlur?: Function;
  active?: boolean;
  ariaExpanded?: boolean;
  disabled?: boolean;
}

export default function NavButton(props: ButtonProps) {
  return (
    <button
      type="button"
      className={props.className || 'nav-link'}
      id={props.id}
      disabled={props.disabled}
      onMouseDown={(e) => {
        e.preventDefault();
      }}
      onClick={(e: any) => {
        if (props.onClick !== undefined) {
          props.onClick(e);
        }
      }}
      onKeyDown={(e: any) => {
        if (props.onKeyDown !== undefined) {
          props.onKeyDown(e);
        }
      }}
      onBlur={(e: any) => {
        if (props.onBlur !== undefined) {
          props.onBlur(e);
        }
      }}
      aria-expanded={props.ariaExpanded}
    >
      {props.active ? <div className="active">{props.label}</div> : props.label}
    </button>
  );
}
